import React, { createContext, useEffect, useState } from 'react'
import { Outlet, useParams, useSearchParams } from 'react-router-dom'
import { useLocalStorage } from 'react-use'
import { get } from '../Common/api'
import consumer from '../Common/cable'

const PublicContext = createContext()
export default PublicContext

export const PublicContextProvider = () => {
  const [loading, setLoading] = useState(false)
  const { boxId, slotId, slotDate } = useParams()
  const [box, setBox] = useState(null)
  const [updatedBox, setUpdatedBox] = useState(null)
  const [slot, setSlot] = useState(null)
  const [params, _] = useSearchParams()
  const [data, setData] = useLocalStorage('slot')
  const [user, setUser] = useLocalStorage('user')
  const [isNow, setIsNow] = useState(false)
  const [siderTitle, setSiderTitle] = useState(null)
  const [siderDisabled, setSiderDisabled] = useState(false)
  const [slotStatus, setSlotStatus] = useState(null)

  const getBox = (id) => {
    setLoading(true)
    get({
      url: `public/boxes/${id}`,
      params: {},
      onSuccess: (json) => {
        setBox(json)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const getNextSlots = (date) => {
    setLoading(true)
    get({
      url: `public/boxes/${box.id}/next_slots`,
      params: { date },
      onSuccess: (json) => {
        const tempBox = { ...box, next_slots: [...box.next_slots, ...json] }
        setBox(tempBox)
        if (data?.boxes) {
          const index = data.boxes.findIndex((b) => b.id === box.id)
          data.boxes[index] = tempBox
          setData({ ...data, boxes: [...data.boxes] })
        } else {
          setData({ ...data, boxes: [{ ...tempBox }] })
        }
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const getSlot = () => {
    setLoading(true)
    get({
      url: `public/slots/${slotId}`,
      params: {},
      onSuccess: (json) => {
        setSlot(json)
        updateStatus(json)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const updateStatus = (json) => {
    if (json?.calendoc_timeout) setSlotStatus('timeout')
    else if (json?.is_cancel) setSlotStatus('cancel')
    else setSlotStatus('confirmed')
  }

  useEffect(() => {
    if (slotId) {
      getSlot()
    }
  }, [slotId])

  useEffect(() => {
    if (slot && slot.box.id !== box?.id) {
      setBox(slot.box)
    }
  }, [slot])

  useEffect(() => {
    if (boxId && boxId !== box?.id) {
      if (data?.boxes && data.boxes.find((b) => b.id === boxId)) {
        setBox(data.boxes.find((b) => b.id === boxId))
      } else {
        getBox(boxId)
      }
    }
    const boxSubscription = consumer.subscriptions.create({ channel: 'PublicSlotsChannel' }, {
      connected: () => { console.log('public connected') },
      disconnected: () => {
        setData({})
        console.log('public disconnected')
      },
      received: (res) => {
        setUpdatedBox(res.box)
      }
    })
    return () => {
      boxSubscription.unsubscribe()
    }
  }, [boxId])

  useEffect(() => {
    if (updatedBox) {
      if (data?.boxes) {
        const index = data.boxes.findIndex((b) => b.id === updatedBox.id)
        if (index !== -1) {
          data.boxes[index].next_slots = updatedBox.next_slots
          setData({ ...data })
        }
      }
      if (box?.id === updatedBox.id) {
        setBox({ ...box, next_slots: updatedBox.next_slots })
      }
    }
  }, [updatedBox])

  useEffect(() => {
    setIsNow(slotDate === 'now')
  }, [slotDate])

  const values = {
    box,
    isNow,
    params,
    loading,
    setLoading,
    data,
    setData,
    siderTitle,
    setSiderTitle,
    siderDisabled,
    setSiderDisabled,
    slot,
    setSlot,
    slotStatus,
    updateStatus,
    getNextSlots,
    user,
    setUser
  }

  return <PublicContext.Provider value={values}>
    <Outlet />
  </PublicContext.Provider>
}
